var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.125 36.6665V18.3332C48.1242 17.5294 47.912 16.74 47.5098 16.0442C47.1075 15.3483 46.5294 14.7705 45.8333 14.3686L29.7917 5.20194C29.0949 4.79967 28.3045 4.58789 27.5 4.58789C26.6955 4.58789 25.9051 4.79967 25.2083 5.20194L9.16667 14.3686C8.4706 14.7705 7.89245 15.3483 7.49022 16.0442C7.08799 16.74 6.87582 17.5294 6.875 18.3332V36.6665C6.87582 37.4703 7.08799 38.2597 7.49022 38.9555C7.89245 39.6514 8.4706 40.2292 9.16667 40.6311L25.2083 49.7978C25.9051 50.2 26.6955 50.4118 27.5 50.4118C28.3045 50.4118 29.0949 50.2 29.7917 49.7978L45.8333 40.6311C46.5294 40.2292 47.1075 39.6514 47.5098 38.9555C47.912 38.2597 48.1242 37.4703 48.125 36.6665Z",
    stroke: "#A97EFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49377 15.9492L27.5 27.5221L47.5063 15.9492",
    stroke: "#A97EFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 50.6V27.5",
    stroke: "#A97EFF",
    strokeWidth: 2.55814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.ddb2303725d5ff429e3a050659067b3a.svg";
export { ForwardRef as ReactComponent };